import { render, staticRenderFns } from "./PersonDonutChart.vue?vue&type=template&id=be77a5e6&scoped=true"
import script from "./PersonDonutChart.vue?vue&type=script&lang=js"
export * from "./PersonDonutChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be77a5e6",
  null
  
)

export default component.exports